import {
	mapActions
} from 'vuex';

import PageBar from '@/components/page-bar/page-bar';
import SidebarMenu from '@/domains/inbox/sidebar-menu/sidebar-menu';
import MessageNew from '@/domains/inbox/message-new/main';

export default {
	name: 'new-message',
	components: {
		PageBar,
		SidebarMenu,
		MessageNew
	},
	methods: {
		...mapActions([
			'setBreadcrumb'
		])
	},
	mounted() {

		this.setBreadcrumb([{
			text: 'Dia a dia'
		}, {
			text: 'Caixa de Entrada'
		}]);

	}
};



// WEBPACK FOOTER //
// ./sources/app/inbox/new-message/index.js